export default {
  PUT_GRAYSCALE_SUCCESS: "Grayscale copy of file success",
  PUT_GRAYSCALE_FAIL: "Grayscale copy of file failed",
};
